import React, { useEffect } from 'react';
import {IconComponent} from "../../reusable/simpleComponents";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {triggerExportAVIList} from "../../../store/layouts/actions";
import {LayoutState} from "../../../store/layouts/types";
import { CamerasState } from '../../../store/cameras/types';
import { Routes } from '../../../types';
import { BrowseState } from '../../../store/browse/types';
import { BookmarkState } from '../../../store/bookmarks/types';
import { RouterState } from 'connected-react-router';

const ExportAviFileUIComponent = () => {
    const dispatch = useDispatch();
    const { exportAVIListOpened, checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { browsePanes } = useSelector<ApplicationState, BrowseState>(state => state.browse);
    const { bookmarks } = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);

    const { location } = useSelector<ApplicationState, RouterState>(state => state.router);

    const panes = location.pathname === Routes.bookmarks ? bookmarks : browsePanes;
    const isAvailable = typeof checkedPane === 'number' && panes[checkedPane];

    const handler = () => {
        dispatch(triggerExportAVIList());
    };

    return(
        <IconComponent classValue={exportAVIListOpened ? 'export active icon' : 'export icon' }
                       handler={ handler }
                       title={isAvailable ? 'Export/Create AVI or Bookmark' : 'Select a Camera to Export'}
        />
    )
};


export default ExportAviFileUIComponent